import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface CompanyNewOrderDialogPayload {
  requestId: string;
  notificationId?: string;
}

@Injectable({ providedIn: 'root' })
export class CompanyNewOrderDialogService {
  private readonly queue: CompanyNewOrderDialogPayload[] = [];
  private readonly activeSubject =
    new BehaviorSubject<CompanyNewOrderDialogPayload | null>(null);

  readonly active$ = this.activeSubject.asObservable();

  /** Enqueue a new-order popup (deduped by requestId). */
  open(payload: CompanyNewOrderDialogPayload): void {
    const requestId = (payload?.requestId || '').trim();
    if (!requestId) {
      return;
    }

    const active = this.activeSubject.value;
    if (active?.requestId === requestId) {
      return;
    }
    if (this.queue.some((q) => q.requestId === requestId)) {
      return;
    }

    if (active) {
      this.queue.push({ ...payload, requestId });
      return;
    }

    this.activeSubject.next({ ...payload, requestId });
  }

  /** Close current dialog and open the next queued order if any. */
  close(): void {
    const next = this.queue.shift() || null;
    this.activeSubject.next(next);
  }
}
